import { render, staticRenderFns } from "./PrintLandfills.vue?vue&type=template&id=0c0f2634&"
import script from "./PrintLandfills.vue?vue&type=script&lang=js&"
export * from "./PrintLandfills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports